import { types } from "mobx-state-tree"

export const genderOptions = ["male", "female"]

export const Gender = types.enumeration("genderOptions", genderOptions)